const pannellumJsScript = `${process.env.REACT_APP_BUCKET}/js/pannellum.js`

export default { pannellumJsScript }
